/* eslint-disable react/prop-types */
import React, { createContext } from 'react'

const ApiMonitoringCtx = createContext()

const ApiMonitoringContext = ({ children }) => {
  return <ApiMonitoringCtx.Provider value={{}}>{children}</ApiMonitoringCtx.Provider>
}

export { ApiMonitoringContext, ApiMonitoringCtx }
